
import { Sliders } from 'lucide-react';

const ToneAdjuster = ({ currentTone, onToneChange }) => {
  const tones = [
    { value: 'formal', label: 'Formal', description: 'Very professional and structured' },
    { value: 'professional', label: 'Professional', description: 'Business-appropriate' },
    { value: 'friendly', label: 'Friendly', description: 'Warm and approachable' },
    { value: 'casual', label: 'Casual', description: 'Relaxed and conversational' },
    { value: 'enthusiastic', label: 'Enthusiastic', description: 'Energetic and excited' }
  ];

  const currentIndex = tones?.findIndex(t => t?.value === currentTone);

  const handleSliderChange = (e) => {
    const index = parseInt(e?.target?.value);
    onToneChange(tones?.[index]?.value);
  };

  return (
    <div>
      <div className="flex items-center gap-2 mb-2">
        <Sliders className="w-4 h-4 text-gray-600" />
        <label className="text-xs font-medium text-gray-700">Tone Adjustment</label>
      </div>
      
      <div className="space-y-2">
        <input
          type="range"
          min="0"
          max={tones?.length - 1}
          value={currentIndex}
          onChange={handleSliderChange}
          className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-blue-600"
        />
        
        <div className="flex items-center justify-between">
          {tones?.map((tone, index) => (
            <button
              key={tone?.value}
              onClick={() => onToneChange(tone?.value)}
              className={`text-xs px-2 py-1 rounded transition-colors ${
                currentTone === tone?.value
                  ? 'bg-blue-600 text-white font-medium' :'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              {tone?.label}
            </button>
          ))}
        </div>
        
        <p className="text-xs text-gray-500 italic">
          {tones?.find(t => t?.value === currentTone)?.description}
        </p>
      </div>
    </div>
  );
};

export default ToneAdjuster;